import { render, staticRenderFns } from "./404.vue?vue&type=template&id=24cad15a"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=24cad15a&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports